'use client';

import { c as _c } from "react/compiler-runtime";
import { useTranslations } from 'next-intl';
import { Button } from '@/components/ui/button';
import { useSignInDialog } from '@/hooks/use-sign-in-dialog';
export function SignIn() {
  const $ = _c(12);
  const t = useTranslations();
  const {
    openDialog
  } = useSignInDialog();
  let t0;
  if ($[0] !== t) {
    t0 = t("common.sign-in");
    $[0] = t;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== openDialog || $[3] !== t0) {
    t1 = <Button className="inline-block bg-linear-to-br from-[#fcd34d] via-[#ef4444] to-[#ec4899] font-semibold dark:text-foreground" onClick={openDialog}>{t0}</Button>;
    $[2] = openDialog;
    $[3] = t0;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[5] !== t) {
    t2 = t("guestbook.signin.description");
    $[5] = t;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] !== t2) {
    t3 = <span className="ml-2">{t2}</span>;
    $[7] = t2;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[9] !== t1 || $[10] !== t3) {
    t4 = <>{t1}{t3}</>;
    $[9] = t1;
    $[10] = t3;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  return t4;
}